import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { roleHasPermission } from "@/auth/shared";
import { ArticleDetail } from "@/components/help-articles/article-detail";
import { useTRPC } from "@/integrations/trpc/react";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/td/help/$slug")({
  loader: async ({ context }) => {
    const viewer = context.viewer;

    const hasPermission =
      viewer &&
      roleHasPermission(viewer.role, {
        tournaments: ["update"],
      });

    if (!hasPermission) {
      throw redirect({ to: "/not-found" });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { slug } = Route.useParams();
  const context = Route.useRouteContext();
  const trpc = useTRPC();

  const { data: article } = useSuspenseQuery(
    trpc.helpArticles.getBySlug.queryOptions({ slug }),
  );

  return (
    <DefaultLayout
      classNames={{
        content:
          "flex flex-col space-y-6 w-full max-w-full md:max-w-3xl px-3 py-12 mx-auto",
      }}
    >
      <ArticleDetail article={article} viewer={context.viewer} />
    </DefaultLayout>
  );
}
